import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import { connect } from 'react-redux';
import { SET_VIDEO_TAGS } from '../../constants/actionTypes';

const mapDispatchToProps = (dispatch) => ({
    setTags: (tag) => dispatch({ type: SET_VIDEO_TAGS, payload: tag })
});

const TagsInput = ({
    handleFocus,
    handleBlur,
    registerRef,
    classes,
    setTags,
    setVideoTags,
    videoTagsInput,
    setVideoTagsInput
}) => {
    const [chips, setChips] = useState([]);

    const handleInputChange = (event) => {
        setVideoTagsInput(event.target.value);
    };

    useEffect(() => {
        setVideoTags(chips);
        setTags(chips);
    }, [chips]);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && videoTagsInput.trim() !== '') {
            setChips((prevChips) => [...prevChips, videoTagsInput.trim()]);
            setVideoTagsInput('');
        }
    };

    const handleDeleteChip = (chipToDelete) => {
        setChips((prevChips) => prevChips.filter((chip) => chip !== chipToDelete));
    };

    return (
        <div>
            <TextField
                label="Enter Text"
                value={videoTagsInput}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                fullWidth
                InputLabelProps={{
                    ref: registerRef
                }}
                inputProps={{
                    style: {
                        color: 'white'
                    }
                }}
                onFocus={handleFocus}
                onBlur={handleBlur}
                className={`${classes.textField} ${classes.label}`}
            />
            <div>
                <div style={{ margin: '2vh 0' }}>
                    {chips.map((chip) => (
                        <Chip
                            key={chip}
                            label={chip}
                            onDelete={() => handleDeleteChip(chip)}
                            sx={{
                                backgroundColor: 'lightgray',
                                color: 'black',
                                margin: '0.5vh'
                            }}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default connect(null, mapDispatchToProps)(TagsInput);
